import { render } from "./CompletionBar.vue?vue&type=template&id=bc3305d8&scoped=true"
import script from "./CompletionBar.vue?vue&type=script&lang=js"
export * from "./CompletionBar.vue?vue&type=script&lang=js"

import "./CompletionBar.vue?vue&type=style&index=0&id=bc3305d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3305d8"]])

export default __exports__